import { parseDateTz } from "@mgdx/shared/src/utils/parseDateTz";
import { Text } from "@mgdx/ui/components/Text";
import clsx from "clsx";

import { TalkMessageDocument } from "../../models/TalkMessageDocument";
import { TalkAvatar } from "../TalkAvatar";
import mainStyles from "./index.module.css";
import styles from "./ReceivedMessage.module.css";
import { TalkMessageImage } from "./TalkMessageImage";

export type ReceivedMessageProps = {
  message: TalkMessageDocument;
  isFirstMessage?: boolean;
  isLastMessage?: boolean;
};

export const ReceivedMessage = ({ message, isFirstMessage, isLastMessage }: ReceivedMessageProps) => {
  return (
    <div
      className={clsx(
        styles.receivedMessage,
        isFirstMessage && mainStyles.isFirstMessage,
        isFirstMessage && styles.isFirstMessage,
        isLastMessage && styles.isLastMessage
      )}
    >
      {isLastMessage && (
        <div className={styles.avatar}>
          <TalkAvatar senderType={message.senderType} />
        </div>
      )}

      <div className={styles.content}>
        {message.body.image ? (
          <TalkMessageImage image={message.body.image} />
        ) : (
          <div className={clsx(mainStyles.balloon, styles.balloon)}>
            <Text>{message.body.content}</Text>
          </div>
        )}
      </div>

      {isLastMessage && (
        <div className={clsx(mainStyles.timestamp, styles.timestamp)}>
          {parseDateTz(message.sentAt)?.format("HH:mm")}
        </div>
      )}
    </div>
  );
};
